import { render, staticRenderFns } from "./DxpCarouselProductCard.vue?vue&type=template&id=0259c3b2&scoped=true"
import script from "./DxpCarouselProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DxpCarouselProductCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DxpCarouselProductCard.vue?vue&type=style&index=0&id=0259c3b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0259c3b2",
  null
  
)

export default component.exports